import { render, staticRenderFns } from "./salesBills.vue?vue&type=template&id=67202704&"
import script from "./salesBills.vue?vue&type=script&lang=js&"
export * from "./salesBills.vue?vue&type=script&lang=js&"
import style0 from "./salesBills.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports